import React from 'react';
import { useGoToHomeSection } from '../../hooks/useGoToHomeSection';

const HomeSectionLink = ({ sectionId, className, children }) => {
  const goToHomeSection = useGoToHomeSection();
  const hash = sectionId.replace(/^#/, '');

  const handleClick = (event) => {
    event.preventDefault();
    goToHomeSection(hash);
  };

  return (
    <a href={`/#${hash}`} className={className} onClick={handleClick}>
      {children}
    </a>
  );
};

export default HomeSectionLink;
